import secureLocalStorage from "react-secure-storage";
import Chip from "@material-ui/core/Chip";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { Popup } from "@progress/kendo-react-popup";
import React, { PureComponent } from "react";
import { toastr } from "react-redux-toastr";
export default class RiskAlertStackHolderComponent extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      alertStackeholderPopup: false,
      temp: [],
    };
    this.onTagsChange = this.onTagsChange.bind(this);
  }
  componentDidMount() {
    let data = this.props.dataItem[this.props.field];
    let value = this.processInput(data);
    if (value && value.length > 0) {
      this.handleChange("init", value);
    }
  }
  processInput(input) {
    if (typeof input === "string") {
      return input.split(",").map((item) => item.trim()); // Optional: trim spaces around items
    } else if (Array.isArray(input)) {
      return input;
    } else {
      return [];
    }
  }
  handleChange = async (e, values) => {
    this.setState({ temp: values });
    if (values.length > 0 && e != "init") {
      this.whitespace(values);
    }
  };

  whitespace = (values) => {
    try {
      let mailvalidity =
        /^([a-zA-Z0-9\._]+)@([a-zA-Z0-9])+.([a-z]+)(.[a-z]+)?$/;
      var input = values[values.length - 1];

      if (
        input.trim().length == 0 ||
        input.length == 0 ||
        (!(input.includes("(") && input.includes(")")) &&
          mailvalidity.test(input) == false)
      ) {
        toastr.error("Please enter a valid email address");

        var temp = values.splice(0, values.length - 1);
        this.setState({ ...this.state, temp: temp });
      }
    } catch (err) {
      console.error(err);
    }
  };

  onTagsChange(e) {
    this.props.onChange({
      dataItem: this.props.dataItem,
      field: this.props.field,
      syntheticEvent: e.syntheticEvent,
      value: this.state.temp,
    });
    if (
      this.props.field &&
      this.props.field === this.props.dataItem.inEdit &&
      this.props.dataItem.riskRegisterId
    ) {
      let emailList = [];
      this.state.temp.map((item) => {
        let emailobj = this.props.dropDownData.filter(
          (data) => data.displayName == item || data.email == item
        );
        if (emailobj && emailobj.length > 0) {
          let val = emailobj[0].email;
          emailList.push(val);
        } else {
          emailList.push(item);
        }
      });

      let updateData = {
        ...this.props.dataItem,
        [this.props.field]: emailList,
      };
      this.closePopup();
      this.props.updateDropdownValue(updateData);
    }
  }

  handleEditCell = () => {
    if (this.props.dataItem.riskRegisterId) {
      this.props.onEditCell(this.props.dataItem, this.props.field);
    }
  };
  closePopup = () => {
    this.props.exitEdit();
  };

  handleOnBlur = (e) => {
    return;
  };

  render() {
    const { dataItem, field } = this.props;
    const loginUserId = parseInt(secureLocalStorage.getItem("loginUserId"));
    const ownerId = dataItem.userId;

    const value = this.props.dataItem[this.props.field];
    if (
      (this.props.field && this.props.field === this.props.dataItem.inEdit) ||
      this.props.dataItem.inEdit === true
    ) {
      return (
        <td>
          <Popup
            show={this.props.field === this.props.dataItem.inEdit}
            popupClass={"popup-content"}
          >
            <div className="deleteModelCont stackHolderSelection">
              <label className="fieldLabel">Select Stakeholders</label>
              <br></br>
              <p style={{ color: "#ffffff" }}>
                Please click on the box below to add the stakeholders. Please
                remember to press the "Enter" key after typing in each external
                stakeholder email address and ensure all email address(es) are
                highlighted before you click 'Submit'.
              </p>
              <Autocomplete
                multiple
                id="emailbcc"
                // autoSelect={true}
                options={this.props.dropDownData.map(
                  (option) => option.displayName
                )}
                freeSolo
                disableCloseOnSelect
                onChange={this.handleChange}
                onBlur={this.handleOnBlur}
                value={this.state.temp}
                renderTags={(value, getTagProps) =>
                  value.map((option, index) => (
                    <Chip
                      variant="outlined"
                      label={option}
                      {...getTagProps({ index })}
                    />
                  ))
                }
                PaperComponent={({ children }) => (
                  <div className="paperComponent">
                    <span>{children}</span>
                  </div>
                )}
                renderInput={(params) => (
                  <TextField {...params} variant="filled" />
                )}
              />

              <div className="btnCont">
                <button
                  className="deleteBtn"
                  type="button"
                  onClick={this.onTagsChange}
                >
                  Submit
                </button>
                <button
                  onClick={this.closePopup}
                  className="cancelBtn"
                  type="button"
                >
                  Cancel
                </button>
              </div>
            </div>
          </Popup>
        </td>
      );
    }
    if (this.props.dataItem.inEdit !== this.props.field) {
      if (loginUserId === ownerId) {
        return (
          <td
            onClick={this.handleEditCell}
            style={{ left: "437px", right: "0px" }}
            title={value}
          >
            <span>{value}</span>
          </td>
        );
      } else {
        return this.props.dataItem.role == "Standard User" ||
          this.props.dataItem.role == "View Only" ? (
          <td style={{ left: "290px", right: "0px" }} title={value}>
            <span>{value}</span>
          </td>
        ) : (
          <td
            onClick={this.handleEditCell}
            style={{ left: "437px", right: "0px" }}
            title={value}
          >
            <span>{value}</span>
          </td>
        );
      }
    }
  }
}
